<div class="step-title">Verify Organization</div>

<div [formGroup]="form">
    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill appGoogleMapsAutocomplete signup d-flex">
                <app-mdb-input-google-maps-autocomplete
                    id="google-maps-autocomplete"
                    mdbInput
                    autocomplete="address"
                    label="Address"
                    [formControl]="addressControl"
                    class="d-flex w-100"
                ></app-mdb-input-google-maps-autocomplete>
            </mdb-form-control>
            <div class="mat-form-field-description mb-3 pr-5">
                <div class="mat-error">{{ getAddressErrorMessage() }}</div>
            </div>
        </div>
    </div>
    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput [formControl]="apt" maxLength="128" label='Unit/Apartment no. (Optional)'></app-mdbp-input>
            </mdb-form-control>
        </div>
    </div>
    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill" [ngStyle]="{'margin-bottom': '48px'}" >
                <app-mdbp-input mdbInput (blur)="onBlurURL()" formControlName="url" autocomplete="url" maxLength="128" label='Website (e.g. http://paybee.io)'></app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.url.touched && form.controls.url.invalid">{{getWebsiteErrorMessage()}}</span>
            </mdb-form-control>
            <div class="mat-form-field-description mb-3 pr-5">
            </div>
        </div>
    </div>
    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput formControlName="orgTaxId" maxLength="128" label='Tax ID'></app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.orgTaxId.touched">{{getTaxIdErrorMessage()}}</span>
            </mdb-form-control>
        </div>
    </div>
</div>

<div class="step-title">Authorized Representative</div>

<div [formGroup]="form">
    <div class="row field-container">
        <div class="col-6">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput 
                    formControlName="ARLFirstName" 
                    autocomplete="given-name" 
                    maxLength="128" 
                    label='First Name'>
                </app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.ARLFirstName.touched && form.controls.ARLFirstName.invalid">Please provide First Name</span>
            </mdb-form-control>
        </div>
        <div class="col-6">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput 
                    formControlName="ARLastName" 
                    autocomplete="family-name" 
                    maxLength="128" 
                    label='Last Name'>
                </app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.ARLastName.touched && form.controls.ARLastName.invalid ">Please provide Last Name</span>
            </mdb-form-control>
        </div>
    </div>
    <div class="row field-container">
        <div class="col-6">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput 
                    formControlName="ArSSNLast4" 
                    maxLength="4" 
                    type="number"
                    label='Last 4 Digits of SSN'>
                </app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.ArSSNLast4.touched">{{ getLast4SSNErrorMessage() }}</span>
            </mdb-form-control>
        </div>
        <div class="col-6">
            <app-datepicker
                [myDatePickerOptions]="myDatePickerOptions"
                [selectedDate]="selectedDate"
                [formControl]="datepicker"
                label="Date of Birth"
                [required]="datepickerRequired"
                [submitted]="submitted"
            ></app-datepicker>
            <span class="form-fill-error error-datetime-signup"  *ngIf="datepicker.touched && datepicker.invalid ">Please provide Date of Birth</span>
        </div>
    </div>
    <div class="row justify-content-end field-container">
        <div class="col-12 col-sm-4 col-lg-2">
            <button class="action-button btn btn--paybee btn--purple w-100" (click)="onNext()"> Next </button>
        </div>
    </div>
</div>

